import { Component, ViewChild, ElementRef } from '@angular/core';
import { ApiService } from '../../services/api.service';

@Component({
  selector: 'app-sql',
  templateUrl: './sql.component.html',
  styleUrls: ['./sql.component.css']
})
export class SqlComponent {
  @ViewChild('sqlEditor') sqlEditor!: ElementRef<HTMLTextAreaElement>;
  command: string = '';
  executionResult: { results: any[], messages: string[] } | null = null;
  error: string = '';
  showResults: boolean = true;
  showCommand: boolean = true;

  constructor(private api: ApiService) { }

  toggleResults() {
    this.showResults = !this.showResults;
  }

  toggleCommand() {
    this.showCommand = !this.showCommand;
  }

  execute() {
    let commandToExecute = this.command;
    const textarea = this.sqlEditor?.nativeElement;

    if (textarea && textarea.selectionStart !== textarea.selectionEnd) {
      commandToExecute = textarea.value.substring(textarea.selectionStart, textarea.selectionEnd);
    }

    if (!commandToExecute || !commandToExecute.trim()) {
      return;
    }

    this.executionResult = null;
    this.error = '';

    this.api.postData('api/Sql/Execute', { command: commandToExecute }).subscribe(
      (res: any) => {
        this.executionResult = res;
      },
      (err) => {
        this.error = 'Error: ' + JSON.stringify(err.error || err.message, null, 2);
      }
    );
  }
  
  getResultString(result: any): string {
    return JSON.stringify(result, null, 2);
  }

  getColumns(resultSet: any[]): string[] {
    if (Array.isArray(resultSet) && resultSet.length > 0) {
      return Object.keys(resultSet[0]);
    }
    return [];
  }
}
